import { IToast, ToastSeverity } from '../interfaces/toast';
import create from 'zustand';
import { devtools } from 'zustand/middleware';
import { DEFAULT_DISMISS_TIME } from '../components/common/Toast';

export interface INotification extends IToast {
  openToast: (props: Omit<IToast, 'open'>) => void;
  closeToast: () => void;
  openSuccessToast: (text: string, dismissTime?: number) => void;
  openErrorToast: (text: string, dismissTime?: number) => void;
  openInfoToast: (text: string, dismissTime?: number) => void;
}

const initialState: IToast = {
  open: false,
  message: '',
  severity: ToastSeverity.SUCCESS,
  dismissTime: DEFAULT_DISMISS_TIME
};

export const useNotification = create<INotification>()(devtools((set, getState) => ({
  ...initialState,
  openToast: (props) => set(prev => ({ ...prev, ...props, open: true })),
  openSuccessToast: (text, dismissTime) => {
    getState().openToast({
      message: text,
      dismissTime: dismissTime || DEFAULT_DISMISS_TIME,
      severity: ToastSeverity.SUCCESS
    });
  },
  openErrorToast: (text, dismissTime) => {
    getState().openToast({
      message: text,
      dismissTime: dismissTime || DEFAULT_DISMISS_TIME,
      severity: ToastSeverity.ERROR
    });
  },
  openInfoToast: (text, dismissTime) => {
    getState().openToast({
      message: text,
      dismissTime: dismissTime || DEFAULT_DISMISS_TIME,
      severity: ToastSeverity.INFO
    });
  },
  closeToast: () => {set(prev => ({ ...prev, ...initialState }));}
})));